var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Window',{attrs:{"window":this.meta}},[_c('template',{slot:"content"},[_c('iframe',{staticClass:"border-0 w-full h-full",attrs:{"src":"https://github1s.com/Obj9527/obj9527.github.io"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }